import Animation from './Animation'
import Player from '@vimeo/player'
import _ from 'lodash'

export default class VideoModal extends Animation {

    static key() {
        return 'videoModal';
    }

    constructor() {
        super(false);
        this.player = null;
        this.navigating = null;
        this.clickCallback = this.onCloseClick.bind(this);
        this.setupElements();
        this.build();
    }

    play( video ) {
        if( this.player ) {
            this.player.loadVideo( video.dataset.videoUrl );
        } else {
            this.player = new Player('player', {
                url: video.dataset.videoUrl
            });
        }

        this.setupButton( video );
        this.setupPreviousNavigation( video );
        this.setupNextNavigation( video );
        super.play();
    }

    setupButton( video ) {
        if( ! _.isEmpty( video.dataset.videoButton ) ) {
            this.modal.querySelector('.modal-footer').prepend( document.createRange().createContextualFragment(
                `<a class="button is-primary is-small" id="scheda_tecnica" target="_blank" href="${video.dataset.videoButton}">Scheda Tecnica</a>`
            ) );
        }
    }

    setupPreviousNavigation( video ) {
        if( video.dataset.previous && ! _.isEmpty( video.dataset.previous ) ) {
            let prev = JSON.parse( video.dataset.previous );
            this.modal.querySelector('.video-navigation .previous').append( document.createRange().createContextualFragment( `<div class="inner">
                            <p class="subtitle"><span>Video Precedente</span> <a data-video-id="${prev.id}"><span class="icon"><i class="fas fa-chevron-left"></i></span> Guarda Video</a></p>
                            <h4 class="title">${prev.name}</h4>
                            <p>${prev.description}</p>
                        </div>` ) );
            this.modal.querySelector('.video-navigation .previous .inner a')
                .addEventListener('click', this.navigate.bind(this))
        }
    }

    setupNextNavigation( video ) {
        if( video.dataset.next && ! _.isEmpty( video.dataset.next ) ) {
            let next = JSON.parse( video.dataset.next );
            this.modal.querySelector('.video-navigation .next').appendChild( document.createRange().createContextualFragment( `<div class="inner">
                            <p class="subtitle"><span>Video Successivo</span> <a data-video-id="${next.id}">Guarda Video <span class="icon"><i class="fas fa-chevron-right"></i></span></a></p>
                            <h4 class="title">${next.name}</h4>
                            <p>${next.description}</p>
                        </div>` ) );
            this.modal.querySelector('.video-navigation .next .inner a')
                .addEventListener('click', this.navigate.bind(this))
        }
    }

    navigate( ev ) {
        this.navigating = document.querySelector('#video-'+ev.currentTarget.dataset.videoId);
        this.reverse();
    }

    setupElements() {
        this.modal = document.querySelector('.video-modal');
        this.videoWrapper = this.modal.querySelector('.video-wrapper');
        this.body = this.modal.querySelector('.modal-body');
    }

    onCloseClick( e ) {
        this.reverse();
    }

    build() {
        this.timeline
            .set(this.modal, {display: 'flex'})
            .to( this.modal, .25, { opacity: 1 } )
            .to( this.videoWrapper, .35, { opacity: 1, y: 0 }  )
            .to( this.body, .25, { css: { transform: 'prespective(2000px) rotateX(0)' } } )
    }

    onComplete() {
        this.modal.querySelector('.close-button').addEventListener('click', this.clickCallback);
        this.player.play()
    }

    onReverseComplete() {
        this.player.pause();
        if( this.modal.querySelector('#scheda_tecnica') ) this.modal.querySelector('#scheda_tecnica').remove();
        if( this.modal.querySelector('.video-navigation .previous .inner') ) this.modal.querySelector('.video-navigation .previous .inner').remove();
        if( this.modal.querySelector('.video-navigation .next .inner') ) this.modal.querySelector('.video-navigation .next .inner').remove();
        this.modal.querySelector('.close-button').removeEventListener('click', this.clickCallback)
        if( this.navigating ) {
            this.play( this.navigating );
            this.navigating = null;
        }
    }

    clear() {
        this.timeline.clear(true);
        this.setupElements();
        this.build();
        return this;
    }

}